import { render, staticRenderFns } from "./DeleteJobSearchAssistance.vue?vue&type=template&id=11204fdd&"
import script from "./DeleteJobSearchAssistance.vue?vue&type=script&lang=js&"
export * from "./DeleteJobSearchAssistance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports